import React from "react";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import { forgetPassword, sendOtp } from "../../../../services/authService";
import useMutation from "../../../../hooks/useMutation";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../forms/Button";

const validation = {
  confirmPassword: { required: true, message: "Confirm Password is Required" },
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message: "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
  otp: { required: true, message: "Please Enter Valid Otp" },
};

const ResetPasswordForm = ({ email }) => {
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({ validationRules: validation });

  const navigate = useNavigate();
  const location = useLocation();

  const {
    mutate,
    error: signUpError,
    isPending: signUpPending,
    data: signUpData,
  } = useMutation({
    mutationFn: async (val) => {
      return await forgetPassword({
        ...val,
        email: location?.state ? location?.state?.email : email,
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200) {
        navigate("/");
      } else {
        toast.warning(res?.message);
      }
    },
  });

  const resendOtp = async () => {
    if (!location?.state?.email && !email) {
      toast.error("Email is missing. Please try again.");
      return;
    }

    try {
      const response = await sendOtp({
        email: location?.state ? location?.state?.email : email,
      });

      if (response?.status === 200 || response?.status === 201) {
        setFieldsValue({ otp: "" });
        toast.success("OTP resent successfully!");
      } else {
        toast.warning(response?.message || "Failed to resend OTP.");
      }
    } catch (error) {
      toast.error("An error occurred while resending OTP.");
    }
  };

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="space-y-4">
        <div className="relative">
          <Input label={"Password"} inputPlaceholder={"Enter Your Password"} inputType={"password"} value={values.password} inputName={"password"} onChange={handleChange} {...formValidate(errors, "password")} />
        </div>
        <div className="relative">
          <Input label={"Confirm Password"} inputPlaceholder={"Enter Confirm Password"} inputType={"password"} value={values.confirmPassword} inputName={"confirmPassword"} onChange={handleChange} {...formValidate(errors, "confirmPassword")} />
        </div>
      </div>
      <div className="relative !mt-8">
        <Button buttonLabel={"Set New Password"} buttonClasses={"!rounded-md !pb-1 w-full"} buttonLabelClasses={"!text-xl font-medium"} />
      </div>
    </form>
  );
};

export default ResetPasswordForm;
